import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { Calendar } from '@ragu-components/ord-types';

export const calendarsResource: OrdResourceProps = {
  key: Resources.calendars,
  name: Resources.calendars,
  options: {},
  recordRepresentation: (record: Calendar): string => record.title,
};
